// extracted by mini-css-extract-plugin
module.exports = {"container":"Skeleton_container__YF3jt","waves":"Skeleton_waves__9zQ5K","animation":"Skeleton_animation__mBhMX"};